import React from 'react'

function UsersStaticsDetailTableThead() {
    return (
        <thead className="UsersStaticsDetailTableThead">
        <tr>
            <th>Nhân viên</th>
            <th>Action</th>
            <th>Thời gian</th>
            <th>Barcode</th>
            <th>SKU</th>
            <th>Brand</th>
            <th>Size</th>
            <th>Lô</th>
            <th>Số thùng</th>
            <th>Đối tác In-ép/May</th>
        </tr>
        </thead>
    )
}

export default UsersStaticsDetailTableThead
